import { IPartnerFinSobRow } from '../../model/types'

import { OVERALL_CATEGORY } from './constants'
import { isCanonicalFinSobRow } from './isCanonicalFinSobRow'

/** Offering totals are normalized to `category=jbp-overall` by the API mapper. For a concrete
 * category, select its own total instead of summing that total together with SubCategory/L3 rows. */
export const isRequestedCategoryTotalRow = (row: IPartnerFinSobRow, category: string): boolean => {
  if (!isCanonicalFinSobRow(row) || row.category !== category) {
    return false
  }

  if (category === OVERALL_CATEGORY) {
    return true
  }

  return (
    (!row.subCategory && !row.l3Category) ||
    (row.subCategory === OVERALL_CATEGORY &&
      (!row.l3Category || row.l3Category === OVERALL_CATEGORY))
  )
}
